<div *transloco="let translate">
  <div fxFlex="100" fxLayout="column" class="px-20">
    <div [formGroup]="form" class="form" fxFlex="100" fxLayout="column" fxLayoutGap="8px">
      <ng-content select="[dates]"></ng-content>

      <div fxFlex="100" fxLayout="row" fxLayoutGap="8px">
        <div fxFlex fxLayout="column" fxLayoutGap="8px">
          <h3 fxFlex="100">{{ translate(TRANSLOCO_PREFIX + '.additionalContainerServices') }}</h3>

          <div fxFlex="100" fxLayout="row" fxLayoutGap="8px">
            <eg-input
              formControlName="customs"
              type="number"
              fxFlex
              [fieldType]="required ? 'M' : '-'"
              [label]="translate(TRANSLOCO_PREFIX + '.customsT1')"
              [changedValue]="isCreated('customs')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
            <eg-input
              formControlName="dangerousGoods"
              type="number"
              fxFlex
              [fieldType]="required ? 'M' : '-'"
              [label]="translate(TRANSLOCO_PREFIX + '.dangerousGoods')"
              [changedValue]="isCreated('dangerousGoods')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
            <eg-input
              formControlName="waste"
              type="number"
              fxFlex
              [fieldType]="required ? 'M' : '-'"
              [label]="translate(TRANSLOCO_PREFIX + '.waste')"
              [changedValue]="isCreated('waste')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
          </div>

          <div fxFlex="100" fxLayout="row" fxLayoutGap="8px">
            <eg-input
              formControlName="container45ft"
              type="number"
              fxFlex
              [fieldType]="required ? 'M' : '-'"
              [label]="translate(TRANSLOCO_PREFIX + '.container45')"
              [changedValue]="isCreated('container45ft')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
            <eg-input
              formControlName="seal"
              type="number"
              fxFlex
              [fieldType]="required ? 'M' : '-'"
              [label]="translate(TRANSLOCO_PREFIX + '.seal')"
              [changedValue]="isCreated('seal')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
            <eg-input
              formControlName="solasVgm"
              type="number"
              fxFlex
              [fieldType]="required ? 'M' : '-'"
              [label]="translate(TRANSLOCO_PREFIX + '.solasVgm')"
              [changedValue]="isCreated('solasVgm')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
          </div>

          <div fxFlex="100" fxLayout="row">
            <eg-input
              formControlName="bhtNumber"
              type="number"
              fxFlex="33"
              [label]="translate(TRANSLOCO_PREFIX + '.bht')"
              [changedValue]="isCreated('bhtNumber')"
            >
              <span egFieldSuffixDirective>€</span>
            </eg-input>
          </div>
        </div>
      </div>

      <h3 fxFlex="100">{{ translate(TRANSLOCO_PREFIX + '.heavyLift') }}</h3>
      <div fxFlex="100" fxLayout="row" fxLayoutGap="8px">
        <eg-input
          formControlName="heavyLiftTruck"
          type="number"
          fxFlex="25"
          [fieldType]="required ? 'M' : '-'"
          [label]="translate(TRANSLOCO_PREFIX + '.heavyLiftTruck')"
          [placeholder]="translate(TRANSLOCO_PREFIX + '.heavyLiftTruck')"
          [changedValue]="isCreated('heavyLiftTruck')"
        >
          <span egFieldSuffixDirective>€</span>
        </eg-input>
        <eg-input
          formControlName="heavyLiftTruckWeight"
          type="number"
          fxFlex="25"
          [fieldType]="required ? 'M' : '-'"
          [label]="translate(TRANSLOCO_PREFIX + '.weight')"
          [placeholder]="translate(TRANSLOCO_PREFIX + '.weight')"
          [changedValue]="isCreated('heavyLiftTruckWeight')"
        >
          <span egFieldSuffixDirective>t</span>
        </eg-input>
      </div>

      <h3 fxFlex="100">{{ translate(TRANSLOCO_PREFIX + '.additionalOptions') }}</h3>
      <ng-content select="[checkboxes]"></ng-content>

      <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start stretch">
        <div fxFlex="25" fxLayout="column" fxLayoutGap="8px">
          <eg-input
            formControlName="sideLoader"
            type="number"
            [fieldType]="sideLoaderRequired ? 'M' : '-'"
            [label]="translate(TRANSLOCO_PREFIX + '.sideLoader')"
            [placeholder]="translate(TRANSLOCO_PREFIX + '.sideLoader')"
            [changedValue]="isCreated('sideLoader')"
          >
            <span egFieldSuffixDirective>€</span>
          </eg-input>
          <eg-input
            formControlName="tipper20ft"
            type="number"
            [fieldType]="tipper20Required ? 'M' : '-'"
            [label]="translate(TRANSLOCO_PREFIX + '.tipper20')"
            [placeholder]="translate(TRANSLOCO_PREFIX + '.tipper20')"
            [changedValue]="isCreated('tipper20ft')"
          >
            <span egFieldSuffixDirective>€</span>
          </eg-input>
        </div>
        <div fxFlex="25" fxLayout="column" fxLayoutGap="8px">
          <eg-input
            formControlName="sideLoaderHighCube"
            type="number"
            [fieldType]="sideLoaderRequired ? 'M' : '-'"
            [label]="translate(TRANSLOCO_PREFIX + '.SLHighCube')"
            [placeholder]="translate(TRANSLOCO_PREFIX + '.SLHighCube')"
            [changedValue]="isCreated('sideLoaderHighCube')"
          >
            <span egFieldSuffixDirective>€</span>
          </eg-input>
          <eg-input
            formControlName="tipper40ft"
            type="number"
            [fieldType]="tipper40Required ? 'M' : '-'"
            [label]="translate(TRANSLOCO_PREFIX + '.tipper40')"
            [placeholder]="translate(TRANSLOCO_PREFIX + '.tipper40')"
            [changedValue]="isCreated('tipper40ft')"
          >
            <span egFieldSuffixDirective>€</span>
          </eg-input>
        </div>
      </div>

      @if (errorMessage) {
        <div fxFlex="100" fxLayout="column" class="pt-10" fxLayoutAlign="flex-start">
          @for (message of errorMessage; track message) {
            <div fxLayout="column" fxLayoutAlign="flex-start" class="mb-2">
              <eg-alert type="error" [message]="message" fxFlex="100"></eg-alert>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
